import { unsafeHTML } from "lit-html/directives/unsafe-html.js"
import type { SYSState } from "../.."
import { html } from "../../"
import { T } from "../../global/globals"
import type {
  HookFormAfterCancel_Type,
  HookFormBeforeCancel_ReturnType,
  HookFormBeforeCancel_Type,
} from "../../global/hooks"
import { HookFormAfterCancel, HookFormBeforeCancel } from "../../global/hooks"
import { DialogResult } from "../actions"
import type { _DialogHolderParams } from "../dialog/sysdialogholder"
import type { SYSOkCancelDeleteFooterType } from "../forms/controls/parts/okcanceldeletefooter"
import { FormIsDirty, FormRemove, FormSave } from "../forms/formapi"
import { SYSFormElement } from "../forms/sysformelement"

import type { CachedRendererData } from "./helpers"
import { _GetTableDialogTitle, FormBodyRenderer } from "./helpers"
import type { EditRowDef, OvlSysColumn } from "./table"
import { _TableFormCloseEditRow } from "./tableapi"

let cachedRendererFn: Map<string, CachedRendererData> = new Map<
  string,
  CachedRendererData
>()
export class SYSTableRowFormBig extends SYSFormElement {
  props: any
  rowData: EditRowDef
  fn: any
  async init() {
    this.rowData = this.props()
    this.formType = "SYSTableRowEdit"
    this.formId = `${this.rowData.tableDef.id}_${this.rowData.key}`
    this.fn = this.actions.app.features[this.rowData.tableDef.feature]?.hooks
    await super.init()
  }

  cancelFn = async () => {
    await _TableFormCloseEditRow(this.rowData.tableDef.id, this.rowData.key, {
      formState: this.formState,
      promptIfDirty: true,
    })
  }

  handleCancel = async () => {
    this.cancelFn()
  }

  getBody = () => {
    return FormBodyRenderer(
      this.formState,
      this.rowData.tableDef,
      this.rowData.row,
      this.rowData.data,
      this.rowData.key
    )
  }
  getHeader() {
    let def = this.rowData.tableDef
    let rowEditMode = this.rowData.mode
    let fnKey
    let translationKey
    if (rowEditMode === "add") {
      fnKey = "SYSAdd"
      translationKey = "SYSAdd"
    } else if (rowEditMode === "edit") {
      fnKey = "SYSEdit"
      translationKey = "SYSTableRowFnEdit"
    } else if (rowEditMode === "copy") {
      fnKey = "SYSCopy"
      translationKey = "SYSTableRowFnCopy"
    }

    let ovlSysState = this.rowData.data.data[this.rowData.key]
      .OvlSysState as OvlSysColumn

    let rowKey = this.rowData.key
    if (rowEditMode === "copy") {
      rowKey = ovlSysState.editRow.fromKey
    } else if (rowEditMode === "add") {
      rowKey = undefined
    }

    if (def.title?.dialogTitle?.doNotDisplay) {
      return
    }

    let captionContent = _GetTableDialogTitle(
      def,
      fnKey,
      T(translationKey),
      1,
      this.rowData.data.data,
      rowKey,
      false,
      this.formState,
      undefined,
      this.rowData.row
    )

    if (captionContent) {
      return html`
        <div class="ovl-panel__header ovl-editview-header">
          <h4 class="ovl-editview-headercontent">${captionContent}</h4>
        </div>
      `
    }
  }
  getFooter() {
    let handleSave = async () => {
      // we can suppressFeedbackSnack here because its granulated handled inside the method
      FormSave(this.formState)
    }

    return html`
      <ovl-okcanceldeletefooter
        .props=${(state: SYSState): SYSOkCancelDeleteFooterType => {
          return {
            cancelFn: this.cancelFn,
            formState: this.formState,
            okFn: handleSave,
            deleteFn: undefined,
            dialog: "SYSTableRowEdit",
          }
        }}
      ></ovl-okcanceldeletefooter>
    `
  }
  async getUI() {
    let dialogHolderParams: _DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        header: () => this.getHeader(),
        body: () => this.getBody(),
        footer: () => this.getFooter(),

        //closedCallbackFn: this.closeEdit,
        customClass: () => {
          let def = this.rowData.tableDef
          return `ovl-table-${def.id} ovl-editform ovl-bigeditform ovl-editform-${def.id}`
        },
        dismissedCallbackFn: () => {
          if (this.formState && !this.formState.locked) {
            this.cancelFn()
          }
        },
        keyHandlerFn: (e) => {
          if (e.key === "Escape") {
            e.stopPropagation()
            if (!(this.formState && FormIsDirty(this.formState))) {
              this.cancelFn()
            }
          }
        },
      },

      dialogType: this.rowData.DialogType,
      instance: `${this.rowData.tableDef.id}_${this.rowData.key}`,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
